import { render, staticRenderFns } from "./PartyLedgerDetails.vue?vue&type=template&id=b21daf1c&"
import script from "./PartyLedgerDetails.vue?vue&type=script&lang=js&"
export * from "./PartyLedgerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports